import type { InjectionKey } from 'vue';

/** Shared Vue provide/inject keys (avoid $parent / $root coupling). */
export const SELECT_TAB_BY_INDEX_KEY: InjectionKey<(tabIndex: number) => void> = Symbol('selectTabByIndex');
export const OPEN_FAST_BUY_MODAL_KEY: InjectionKey<() => void> = Symbol('openFastBuyModal');

export type TabApi = {
  name: string;
  badge?: unknown;
  disabled?: boolean;
  hash?: string;
  id?: string | null;
  isActive: boolean;
};

export type TabRegistrar = (_tab: TabApi) => void;

export const REGISTER_TAB_KEY: InjectionKey<TabRegistrar> = Symbol('registerTab');
export const UNREGISTER_TAB_KEY: InjectionKey<TabRegistrar> = Symbol('unregisterTab');
